module.exports = __webpack_public_path__ + "img/gatorz-banner.3346f518.webp";